/* Development */

import { getSubDomain, type IEnvironmentTemplate } from './lib';

export const environment = () => {
  const envTemplate = {
    variant: '',
    baseUrl: 'autoideas'
    // } as const satisfies IEnvironmentTemplate;
  } as IEnvironmentTemplate;

  const subdomain = getSubDomain(envTemplate);
  return {
    production: false,
    //api: `https://carcastle.autozaki.com/api`,
    api: `https://${subdomain}autozaki.in/api`,
    // api: `https://dms.mycar-india.com/api`,
    // api: 'http://192.168.0.116:8000/api',
    base_path: 'https://pub-63c973c88111442dbc6a2ac741c81bb7.r2.dev/',
    dms: `https://${subdomain}autozaki.in/`,
    domain: `https://${subdomain}autoideas.in`
  };
};

/* Production */

// export const environment = {
//   production: true,
//   api: 'https://dms.my-car.com/api',
//   base_path: 'https://s3.me-south-1.amazonaws.com/storage.siarty.com/',
//   dms: 'https://dms.my-car.com/',
// };
